import React, { useState, useEffect } from 'react'
// import './styles/style.css'
import AdminLayout from './Admin/AdminLayout'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'

import PushTask from './Admin/PushTask'
import PushTaskList from './Admin/PushTaskList'
import ContactSettings from './Admin/ContactSettings'

import { AuthContext } from './AuthContext'
import axios from 'axios'

// 創建包裝組件來處理編輯模式
const PushTaskWrapper = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const editMode = location.state?.editMode || false
  const taskId = location.state?.taskId || null

  return (
    <PushTask
      editMode={editMode}
      taskId={taskId}
      onCancel={() => {
        // 取消時返回任務列表
        navigate('/admin/push-task-list')
      }} // 🔄 返回上一頁
      onUpdate={(updatedTask) => {
        // 更新成功後直接返回任務列表
        console.log('任務已更新:', updatedTask)
        navigate('/admin/push-task-list')
      }}
    />
  )
}

function AdminApp() {
  const [currentUser, setCurrentUser] = useState(null)
  const [loginShow, setLoginShow] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const baseUrl = process.env.REACT_APP_BASE_URL

  // 前台的 cookie 選項
  const expiresTime = parseFloat(process.env.REACT_APP_EXPIRES_TIME)
  const cookieOptions = { expires: expiresTime, secure: true }

  // 設置 cookie 函數
  const setCookie = (name, value, options = {}) => {
    Cookies.set(name, value, { ...options, secure: true })
  }

  // 獲取 cookie 函數
  const getCookie = (name) => Cookies.get(name)

  // 刪除 cookie 函數
  const removeCookie = (name) => Cookies.remove(name)

  // 延長 cookie 過期時間
  function extendCookie() {
    if (Cookies.get('session')) {
      const getUser = JSON.parse(Cookies.get('session'))
      Cookies.set('session', JSON.stringify(getUser), cookieOptions)
    }
  }

  // Discord 通知函數（可選）
  async function sendDiscordNotification(message) {
    try {
      await axios.post('/api/send-notification', {
        content: message,
      })
    } catch (error) {
      console.error('Failed', error)
    }
  }

  // 檢查是否是第一次訪問
  const checkFirstVisit = () => {
    if (!getCookie('visited')) {
      setCookie('visited', 'true', { expires: 365 })
      return true
    }
    return false
  }

  // 處理登入邏輯（與前台相同）
  const handleLoginStatus = () => {
    const sessionCookie = getCookie('session')
    const isFirstVisit = checkFirstVisit()

    if (!sessionCookie) {
      if (isFirstVisit) {
        console.log('第一次訪問網站')
        return { status: 'first_visit', user: null }
      } else {
        console.log('登入已逾時，請重新登入')
        return { status: 'login_expired', user: null }
      }
    } else {
      try {
        const user = JSON.parse(sessionCookie)
        console.log('正常登入狀態')
        return { status: 'logged_in', user }
      } catch (error) {
        console.error('Session cookie 解析錯誤', error)
        removeCookie('session')
        return { status: 'error', user: null }
      }
    }
  }

  // 初始化檢查登入狀態
  useEffect(() => {
    const { status, user } = handleLoginStatus()

    switch (status) {
      case 'first_visit':
        // 處理第一次訪問的邏輯
        setLoginShow(true)
        break
      case 'login_expired':
        alert('登入已逾時，請重新登入')
        setLoginShow(true)
        break
      case 'logged_in':
        setCurrentUser(user)
        break
      case 'error':
        alert('發生錯誤，請重新登入')
        setLoginShow(true)
        break
      default:
        setLoginShow(true)
        break
    }
  }, [])

  useEffect(() => {
    console.log('loginShow', loginShow)
  }, [loginShow])

  return (
    <div className="App">
      {/* 簡單的密碼登入框 */}

      <AuthContext.Provider
        value={{
          baseUrl,
          currentUser,
          isLoading,
          setIsLoading,
          setLoginShow,
          extendCookie,
          sendDiscordNotification,
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              <AdminLayout
                currentUser={currentUser}
                setCurrentUser={setCurrentUser}
                loginShow={loginShow}
                setLoginShow={setLoginShow}
                redirectTo={redirectTo}
                setRedirectTo={setRedirectTo}
                sendDiscordNotification={sendDiscordNotification}
              />
            }
          >
            <Route path="/" element={<PushTaskWrapper />} />{' '}
            {/* 🔄 使用包裝組件 */}
            <Route path="/push-task" element={<PushTaskWrapper />} />{' '}
            {/* 🔄 使用包裝組件 */}
            <Route path="/push-task-list" element={<PushTaskList />} />
            <Route path="/contact-settings" element={<ContactSettings />} />
            {/* 404 回到推送任務 */}
            <Route path="*" element={<PushTask />} />
          </Route>
        </Routes>
      </AuthContext.Provider>
    </div>
  )
}

export default AdminApp
